const MainContainer = ({ children, className }) => {
  return (
    <div
      className={
        " w-full h-full mx-auto relative flex-1 mt-[4rem] sm:mt-0 pt-3 pb-6 overflow-auto px-2 2xl:px-20 flex flex-col text-text-1  " +
        className
      }
    >
      {/* <div className="h-full w-full flex-1 overflow-auto bg-red-400"> */}
      {children}
      {/* </div> */}
    </div>
  );
};

export default MainContainer;
